module.exports = __webpack_public_path__ + "img/user.c26136b7.svg";